exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-red[data-v-89ddb1d0] {\n  color: #f56c6c;\n}\n", ""]);

// exports
